<div class="record-notes-popup">
  <div
    class="popup-backdrop"
    (click)="onClose()"
    (keyup.escape)="onClose()"
    tabindex="0"
    role="button"
    aria-label="Close popup"
  ></div>

  <div class="popup-container">
    <div class="popup-header">
      <div class="title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="#495057"
          width="18px"
          height="18px"
          viewBox="0 0 640 640"
        >
          <path
            d="M128.1 64C92.8 64 64.1 92.7 64.1 128L64.1 512C64.1 547.3 92.8 576 128.1 576L274.3 576L285.2 521.5C289.5 499.8 300.2 479.9 315.8 464.3L448 332.1L448 234.6C448 217.6 441.3 201.3 429.3 189.3L322.8 82.7C310.8 70.7 294.5 64 277.6 64L128.1 64zM389.6 240L296.1 240C282.8 240 272.1 229.3 272.1 216L272.1 122.5L389.6 240zM332.3 530.9L320.4 590.5C320.2 591.4 320.1 592.4 320.1 593.4C320.1 601.4 326.6 608 334.7 608C335.7 608 336.6 607.9 337.6 607.7L397.2 595.8C409.6 593.3 421 587.2 429.9 578.3L548.8 459.4L468.8 379.4L349.9 498.3C341 507.2 334.9 518.6 332.4 531zM600.1 407.9C622.2 385.8 622.2 350 600.1 327.9C578 305.8 542.2 305.8 520.1 327.9L491.3 356.7L571.3 436.7L600.1 407.9z"
          />
        </svg>
        <h3>Lead Notes - {{ companyName }}</h3>
      </div>
      <button type="button" class="close-btn" (click)="onClose()" title="Close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="popup-content">
      <!-- Create new note section -->
      @if (
        !isLoading && !isCreating && !editingNoteId && !hasCurrentUserNote()
      ) {
        <div class="create-note-section">
          <button
            type="button"
            class="create-note-btn"
            (click)="startCreatingNote()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Note
          </button>
        </div>
      }

      <!-- New note creation form -->
      @if (isCreating) {
        <div class="note-form-section">
          <div class="form-header">
            <h4>Create New Note</h4>
            <button
              type="button"
              class="btn-attach"
              (click)="openFilePicker()"
              [disabled]="isSaving"
              title="Attach File"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                ></path>
              </svg>
              <span>Attach File</span>
            </button>
          </div>
          <div class="quill-wrapper">
            <quill-editor
              [(ngModel)]="newNoteContent"
              [modules]="quillConfig"
              style="width: 100%; height: 200px; margin-bottom: 16px"
              placeholder="Write your note here..."
            ></quill-editor>
          </div>
          <div class="terms-of-use-text">
            <span>
              By adding this note, I agree to the ACC Data Hub
              <a
                href="/terms-of-use"
                target="_blank"
                (click)="$event.stopPropagation()"
                >Terms Of Use</a
              >.
            </span>
          </div>
          <div class="form-actions">
            <button
              type="button"
              class="btn btn-primary"
              (click)="saveNewNote()"
              [disabled]="!newNoteContent || !newNoteContent.trim() || isSaving"
            >
              @if (isSaving) {
                <div class="spinner-small"></div>
                <span>Saving...</span>
              } @else {
                <span>Save</span>
              }
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              (click)="cancelCreating()"
              [disabled]="isSaving"
            >
              Cancel
            </button>
          </div>
        </div>
      }

      <!-- Notes list -->
      <div class="notes-list-section">
        @if (isLoading) {
          <div class="loading-state">
            <div class="spinner"></div>
            <span>Loading notes...</span>
          </div>
        } @else if (notes.length === 0) {
          <div class="empty-state">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              ></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10,9 9,9 8,9"></polyline>
            </svg>
            <p>No notes available</p>
            <span>Be the first to add a note for this record</span>
          </div>
        } @else {
          <div class="notes-list">
            @for (note of notes; track note.id) {
              <div class="note-item" [class.current-user]="canEditNote(note)">
                <div class="note-header">
                  <div class="note-author">
                    <div
                      class="author-avatar"
                      [class.no-image]="
                        !getProfileImageUrl(
                          note.profile_image_path,
                          note.user.username
                        )
                      "
                    >
                      @if (
                        getProfileImageUrl(
                          note.profile_image_path,
                          note.user.username
                        );
                        as imageUrl
                      ) {
                        <img
                          [src]="imageUrl"
                          alt="profile"
                          class="profile-image"
                        />
                      } @else {
                        <span>{{
                          (note.user.first_name || note.user.username || "")
                            .charAt(0)
                            .toUpperCase()
                        }}</span>
                      }
                    </div>
                    <div class="author-info">
                      <div class="author-name">
                        {{ note.user.first_name }} {{ note.user.last_name }}
                      </div>
                      <div class="note-date">
                        {{ note.updated_on_utc | date: "medium" }}
                      </div>
                    </div>
                  </div>

                  <div class="header-right">
                    @if (!canEditNote(note) && getConnectionDisplayName(note)) {
                      <div
                        class="connection-badge"
                        title="{{ getConnectionDisplayName(note) }}"
                      >
                        {{ getConnectionDisplayName(note) }}
                      </div>
                    }

                    <div class="note-actions">
                      @if (canEditNote(note) && editingNoteId !== note.id) {
                        <button
                          type="button"
                          class="action-btn share-btn"
                          (click)="shareNote(uniqueId, note)"
                          title="Share note"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            stroke="currentColor"
                            stroke-width="2"
                            fill="currentColor"
                          >
                            <path
                              fill="currentColor"
                              stroke="currentColor"
                              stroke-width="2"
                              d="M352 224l-46.5 0c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8l-2.5 0c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144l80 0 0-61.3C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2l-3.7 0c-17.7 0-32-14.3-32-32l0-64zM80 96c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 112C0 67.8 35.8 32 80 32l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 96z"
                            />
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="action-btn edit-btn"
                          (click)="startEditingNote(note)"
                          title="Edit note"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <path
                              d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
                            ></path>
                            <path
                              d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
                            ></path>
                          </svg>
                        </button>
                        <button
                          type="button"
                          class="action-btn delete-btn"
                          (click)="confirmDelete(note.id)"
                          title="Delete note"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <polyline points="3,6 5,6 21,6"></polyline>
                            <path
                              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                            ></path>
                            <line x1="10" y1="11" x2="10" y2="17"></line>
                            <line x1="14" y1="11" x2="14" y2="17"></line>
                          </svg>
                        </button>
                      }
                      @if (!canEditNote(note) && editingNoteId !== note.id) {
                        <button
                          type="button"
                          class="action-btn report-btn"
                          (click)="reportNote(note)"
                          title="Flag note"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path
                              d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"
                            ></path>
                            <line x1="4" y1="22" x2="4" y2="15"></line>
                          </svg>
                        </button>
                      }
                    </div>
                  </div>
                </div>

                <div class="note-content">
                  @if (editingNoteId === note.id) {
                    <div class="note-edit-form">
                      <div class="edit-form-header">
                        <button
                          type="button"
                          class="btn-attach"
                          (click)="openFilePicker()"
                          [disabled]="isSaving"
                          title="Attach File"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <path
                              d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"
                            ></path>
                          </svg>
                          <span>Attach File</span>
                        </button>
                      </div>
                      <div class="quill-wrapper">
                        <quill-editor
                          [(ngModel)]="editNoteContent"
                          [modules]="quillConfig"
                          style="
                            width: 100%;
                            height: 150px;
                            margin-bottom: 16px;
                          "
                        ></quill-editor>
                      </div>
                      <div class="terms-of-use-text">
                        <span>
                          By saving this note, I agree to the ACC Data Hub
                          <a
                            href="/terms-of-use"
                            target="_blank"
                            (click)="$event.stopPropagation()"
                            >Terms Of Use</a
                          >.
                        </span>
                      </div>
                      <div class="form-actions">
                        <button
                          type="button"
                          class="btn btn-primary"
                          (click)="saveEditedNote()"
                          [disabled]="
                            !editNoteContent ||
                            !editNoteContent.trim() ||
                            isSaving
                          "
                        >
                          @if (isSaving) {
                            <div class="spinner-small"></div>
                            <span>Saving...</span>
                          } @else {
                            <span>Save</span>
                          }
                        </button>
                        <button
                          type="button"
                          class="btn btn-secondary"
                          (click)="cancelEditing()"
                          [disabled]="isSaving"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  } @else {
                    <div class="note-text-container">
                      <div
                        class="note-text"
                        [class.collapsed]="
                          !isNoteExpanded(note.id) &&
                          shouldShowToggle(note.note)
                        "
                        [innerHTML]="processNoteContent(note.note) | safeHtml"
                        (click)="handleNoteInteraction($event)"
                        (keydown)="handleNoteInteraction($event)"
                        tabindex="-1"
                      ></div>
                      @if (shouldShowToggle(note.note)) {
                        <button
                          type="button"
                          class="toggle-btn"
                          (click)="toggleNoteExpansion(note.id)"
                        >
                          {{
                            isNoteExpanded(note.id) ? "Show less" : "Show more"
                          }}
                        </button>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

    @if (sharingNoteId) {
      <div
        class="share-modal-overlay"
        (appClickOutside)="onCloseUsersDropDown()"
      >
        <div class="share-modal">
          <!-- Header -->
          <div class="share-modal-header">
            <div class="share-header-content">
              <div class="share-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <circle cx="18" cy="5" r="3"></circle>
                  <circle cx="6" cy="12" r="3"></circle>
                  <circle cx="18" cy="19" r="3"></circle>
                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
                </svg>
              </div>
              <div class="share-title">
                <h4>Share Note</h4>
                <p>Select CDFIs to share this note with</p>
              </div>
            </div>
            <button
              type="button"
              class="close-share-btn"
              (click)="onCloseUsersDropDown()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <!-- Selected Connections Display -->
          @if (getSelectedConnections().length > 0) {
            <div class="selected-connections-section">
              <div class="selected-label">
                <span>Share to ({{ getSelectedConnections().length }})</span>
              </div>
              <div class="selected-connections-list">
                @for (
                  connection of getSelectedConnections();
                  track connection
                ) {
                  <div class="selected-connection-chip">
                    <span class="connection-name">{{ connection }}</span>
                    <button
                      type="button"
                      class="remove-connection-btn"
                      (click)="removeConnection(connection)"
                      title="Remove connection"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                      >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Connections List -->
          <div class="connections-section">
            <div class="connections-header">
              <h5>Assigned CDFIs</h5>
              @if (assignedRecordConnections.length > 0) {
                <span class="connections-count"
                  >{{ assignedRecordConnections.length }} available</span
                >
              }
            </div>

            <div class="connections-list-wrapper">
              @if (isLoadingUsers) {
                <div class="loading-connections">
                  <div class="loading-spinner"></div>
                  <span>Loading ...</span>
                </div>
              } @else if (assignedRecordConnections.length === 0) {
                <div class="no-connections-state">
                  <div class="no-connections-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                      ></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <div class="no-connections-text">
                    <p>No CDFIs available</p>
                    <span>This record has no assigned CDFIs to share with</span>
                  </div>
                </div>
              } @else {
                <div class="connections-list">
                  @for (suggestion of assignedRecordConnections; track $index) {
                    <div
                      class="connection-item"
                      [class.selected]="
                        connectionCheckboxState[suggestion.connection_name]
                      "
                    >
                      <label class="connection-checkbox">
                        <input
                          type="checkbox"
                          [(ngModel)]="
                            connectionCheckboxState[suggestion.connection_name]
                          "
                          (change)="
                            onUsersSelection(
                              $event,
                              suggestion.connection_name,
                              true
                            )
                          "
                        />
                        <div class="checkbox-custom">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="3"
                          >
                            <polyline points="20,6 9,17 4,12"></polyline>
                          </svg>
                        </div>
                        <div class="connection-info">
                          <div
                            class="connection-avatar"
                            [class.no-image]="
                              suggestion.cdfi_logo_path === null
                            "
                          >
                            @if (suggestion.cdfi_logo_path) {
                              <img
                                [src]="getImageUrl(suggestion.cdfi_logo_path)"
                                alt="logo"
                                class="profile-image"
                                [class.no-border-radius]="true"
                              />
                            } @else {
                              <span>{{
                                (
                                  suggestion.display_name ||
                                  suggestion.connection_name
                                )
                                  .charAt(0)
                                  .toUpperCase()
                              }}</span>
                            }
                          </div>
                          <div class="connection-details">
                            <div class="connection-display-name">
                              {{
                                suggestion.display_name ||
                                  suggestion.connection_name
                              }}
                            </div>
                            @if (
                              suggestion.display_name &&
                              suggestion.display_name !==
                                suggestion.connection_name
                            ) {
                              <div class="connection-username">
                                {{ suggestion.connection_name }}
                              </div>
                            }
                          </div>
                        </div>
                      </label>
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="share-modal-footer">
            <div class="footer-actions">
              <button
                type="button"
                class="btn-cancel"
                (click)="onCloseUsersDropDown()"
                [disabled]="isSharing"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn-share"
                (click)="shareWithSelectedPeople()"
                [disabled]="
                  isSharing ||
                  assignedRecordConnections.length === 0 ||
                  !hasShareChanges()
                "
              >
                @if (isSharing) {
                  <div class="spinner-small"></div>
                  <span>Sharing...</span>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22,2 15,22 11,13 2,9 22,2"></polygon>
                  </svg>
                  <span>Save</span>
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Delete confirmation popup -->
    @if (showDeleteConfirm) {
      <app-popup
        [heading]="'Delete Note'"
        [confirmText]="'Delete'"
        [cancelText]="'Cancel'"
        (confirmClicked)="deleteNote()"
        (cancelClicked)="cancelDelete()"
      >
        <p>
          Are you sure you want to delete this note? This action cannot be
          undone.
        </p>
      </app-popup>
    }
    <!-- File Picker Modal -->
    @if (showFilePicker) {
      <app-popup
        [heading]="'Select File to Attach'"
        [showFooterButtons]="false"
        [showCloseIcon]="true"
        (cancelClicked)="closeFilePicker()"
      >
        <div class="file-picker-content">
          @if (isLoadingFiles) {
            <div class="loading-files">
              <div class="spinner-small"></div>
              <span>Loading files...</span>
            </div>
          } @else if (leadFiles.length === 0) {
            <div class="empty-files">
              <p>No files attached to this lead.</p>
              <small
                >Use the "Attachments" panel to upload or attach files.</small
              >
            </div>
          } @else {
            <div class="files-list">
              @for (file of leadFiles; track file.id) {
                <div
                  class="file-item"
                  (click)="selectFileToAttach(file)"
                  (keyup.enter)="selectFileToAttach(file)"
                  (keyup.space)="selectFileToAttach(file)"
                  tabindex="0"
                  role="button"
                >
                  <div class="file-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                      ></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                  </div>
                  <div class="file-info">
                    <div class="file-name">
                      {{ file.file.file_name || "Unknown" }}
                    </div>
                    <div class="file-meta">
                      <span class="meta-item">
                        {{ file.file.uploaded_user.first_name || "Unknown" }}
                        @if (file.file.uploaded_user.last_name) {
                          {{ file.file.uploaded_user.last_name }}
                        }
                      </span>
                      <span class="meta-separator">•</span>
                      <span class="meta-item">
                        {{ file.file.uploaded_datetime | date: "mediumDate" }}
                      </span>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </app-popup>
    }
  </div>
</div>
